import { Box } from "@mui/material";
import { Model } from "survey-core";
import arrowRightIcon from "assets/icons/arrow-right.svg";
import SurveyWrapper from "components/v3/sharedComponents/surveys/SurveyWrapper";

export const SURVEY_ID = "member-feedback-survey";

type MemberFeedbackSurveyProps = {
  onComplete: () => void;
};

const MemberFeedbackSurvey = ({
  onComplete
}: MemberFeedbackSurveyProps): React.ReactElement => {
  const handleOnSurveyInstantiated = (surveyModel: Model): void => {
    surveyModel.pagePrevText = "Back";
  };

  return (
    <Box
      sx={{
        width: "100%",
        "& > .MuiGrid-root": {
          marginBottom: "0 !important"
        },
        "& .sd-container-modern": {
          height: "auto !important",
          maxHeight: "none",
          minHeight: 0,
          overflow: "visible",
          padding: "0 !important"
        },
        "& .sd-footer": {
          paddingTop: "24px !important"
        },
        "& .sd-html h3": {
          fontSize: "1.25rem !important",
          fontWeight: "700 !important",
          lineHeight: 1.4
        },
        "& .sd-rating": {
          "--primary": "#F5C518",
          "--sjs-primary-backcolor": "#F5C518"
        },
        "& .sd-rating__item-star": {
          zoom: "calc(2 / 3)"
        },
        "& .sd-rating__item-star--selected svg, & .sd-rating__item-star--highlighted svg":
          {
            fill: "#F5C518",
            stroke: "#F5C518"
          },
        "& .sd-rating__item-star--unhighlighted svg": {
          fill: "transparent",
          stroke: "currentColor"
        },
        "& .sd-navigation__complete-btn": {
          backgroundImage: `url(${arrowRightIcon})`,
          backgroundPosition: "right 18px center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "20px 20px",
          padding: "8px 52px 8px 24px !important"
        }
      }}
    >
      <SurveyWrapper
        containerClassName="member-feedback-survey-container"
        focusFirstQuestionAutomatic={false}
        onComplete={onComplete}
        onSurveyInstantiated={handleOnSurveyInstantiated}
        overrideNextButtonEnabled={true}
        rehydratePreviousAnswers={false}
        surveyId={SURVEY_ID}
        useStoredSurveyData={false}
      />
    </Box>
  );
};

export default MemberFeedbackSurvey;
